import { InjectionToken } from '@angular/core';

export type CmsLpBadgeState = 'success' | 'primary';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CMS_LP_BADGE_STATE: InjectionToken<CmsLpBadgeState> = new InjectionToken<CmsLpBadgeState>(
  'cmsLpBadgeState',
  {
    factory: () => 'success'
  }
);
